import { render, staticRenderFns } from "./material-box-list.vue?vue&type=template&id=498b0f3f&scoped=true"
import script from "./material-box-list.vue?vue&type=script&lang=js"
export * from "./material-box-list.vue?vue&type=script&lang=js"
import style0 from "./material-box-list.vue?vue&type=style&index=0&id=498b0f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b0f3f",
  null
  
)

export default component.exports